import React from "react";
import { Link } from "react-router-dom";

// Section label for the League Play landing. Bold near-black title on the left,
// a teal "View all" on the right when the section has a full page behind it.
//
// Client Rev 3: "I looked through my notes for the Status line and View all
// labels throughout league play… Right now, 'Starts in' and 'View all' look the
// same color." They did — both were #006565. The locked system separates them:
//
//   Starts in 11h   #006565      Ends in 3d   #35B23C
//   Ended Aug 22    secondary    View all     #004C50
//
// So a LINK is #004C50 and a STATUS is one of the other three. The status values
// live in leagueStatus.previewStatus, which is the one place that decides them.
const SectionHeader = ({ title, viewAllTo, className = "" }) => (
  <div className={`flex items-end justify-between mb-3 ${className}`}>
    <h2 className="font-montserrat font-bold text-lg md:text-xl text-[#0F172A]">{title}</h2>
    {viewAllTo && (
      <Link
        to={viewAllTo}
        className="font-semibold text-sm text-[#004C50] hover:underline shrink-0"
      >
        View all
      </Link>
    )}
  </div>
);

export default SectionHeader;
